import { all, call, put, takeLatest } from 'redux-saga/effects';
import { gmailLogin, getGmailLogin, getEmails } from '../routines';
import { request } from '../../common/util/RestClient';
import envConfig from '../../config';

export function* gmailLoginSaga({ payload }) {
  try {
    const URL = `${envConfig.APIG_URL}core/email-settings/gmail/login`;
    const config = {
      method: 'POST',
      payload: payload.authCode,
    };
    const response = yield call(request, URL, config);
    yield put(gmailLogin.success(response));
  } catch (err) {
    yield put(gmailLogin.failure(err));
  }
}
export function* getGmailLoginSaga() {
  try {
    const URL = `${envConfig.APIG_URL}core/email-settings/gmail/login`;
    const response = yield call(request, URL);
    yield put(getGmailLogin.success(response));
  } catch (err) {
    yield put(getGmailLogin.failure(err));
  }
}

export function* getEmailsSaga() {
  try {
    const URL = `${envConfig.APIG_URL}core/email-settings/gmail`;
    const response = yield call(request, URL);
    yield put(getEmails.success(response));
  } catch (err) {
    yield put(getEmails.failure(err));
  }
}

export default function* root() {
  yield all([
    takeLatest(gmailLogin.TRIGGER, gmailLoginSaga),
    takeLatest(getEmails.TRIGGER, getEmailsSaga),
    takeLatest(getGmailLogin.TRIGGER, getGmailLoginSaga),
  ]);
}
